<!--
 * @Description: 车型识别一体机-中
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-24 15:57:14
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-24 18:39:17
 -->
<template>
  <div class="middleModule"></div>
</template>

<script>
export default {
  name: 'middleModule',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .middleModule {
    width: 90%;
    aspect-ratio: 6.09/6.6;
    background: pink;
    background: url('/static/img/layout/vehicleIdentification.png');
    background-size: 100% 100%;
    margin: 13% auto;
  }
</style>
